import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CreditUsageAnalyticsPageStore } from 'pages/analytics/pages/creditUsage/store/creditUsageAnalyticsPageStore'

const CreditUsageAnalyticsPageContext = createContext<CreditUsageAnalyticsPageStore | null>(null)

export const useCreditUsageAnalyticsPageContext = () => {
  const context = useContext(CreditUsageAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with CreditUsageAnalyticsPageProvider'
    )

  return context
}

export const CreditUsageAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new CreditUsageAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <CreditUsageAnalyticsPageContext.Provider value={store}>
      {children}
    </CreditUsageAnalyticsPageContext.Provider>
  )
}
